import React, { useState } from "react";
import OfflineSetupControlForm from "./OfflineSetupControlForm/OfflineSetupControlForm";
import OfflineSetupControlKonva from "./OfflineSetupControlKonva/OfflineSetupControlKonva";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";

export default function OfflineSetupControl() {
	const [floorplan, setFloorplan] = useState(null);
	const [rooms, setRooms] = useState(null);
	const [uniqueId, setUniqueId] = useState(null);
	const [error, setError] = useState(false);
	const param = useParams();
	const navigate = useNavigate();
	if (error && param?.id) navigate("/setup/offline-setup");
	return (
		<>
			<Helmet>
				<title>Offline-Setup</title>
				<meta name="description" content="Offline Setup" />
			</Helmet>

			<div className="container-fluid">
				<div className="row">
					<OfflineSetupControlKonva
						floorplan={floorplan}
						rooms={rooms}
						setUniqueId={setUniqueId}
					/>
					<OfflineSetupControlForm
						floorplan={floorplan}
						setFloorplan={setFloorplan}
						setRooms={setRooms}
						uniqueId={uniqueId}
						setUniqueId={setUniqueId}
						setError={setError}
					/>
				</div>
			</div>
		</>
	);
}
